import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  EventEmitter,
  input,
  Output,
} from '@angular/core';
import { FinoIconModule } from '@fino-ui/icon';
import { TranslationModule } from '@fino-ui/translation';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrl: './file-upload.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PdfJsViewerModule, FinoIconModule, TranslationModule],
})
export class FileUploadComponent {
  fileName: string;
  fileAsBase64: string;
  fileAsBinary: Uint8Array;

  isPDFUpload = input.required({ transform: booleanAttribute });
  isImageUpload = input.required({ transform: booleanAttribute });

  @Output() fileSelected = new EventEmitter<string>();

  accept = computed(() =>
    this.isImageUpload() ? 'image/png' : 'application/pdf',
  );

  icon = computed(() =>
    this.isImageUpload() ? 'Cloud Image' : 'Office File Pdf 1',
  );

  onFileChange(event) {
    const file = event.target.files[0];
    this.fileName = file.name;

    const reader = new FileReader();

    reader.onload = () => {
      this.fileAsBase64 = reader.result as string;
      this.fileAsBinary = this.convertDataURIToBinary(this.fileAsBase64);
      this.fileSelected.next(this.fileAsBase64);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  }

  convertDataURIToBinary(dataURI) {
    const BASE64_MARKER = ';base64,';

    const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
    const base64 = dataURI.substring(base64Index);
    const raw = window.atob(base64);
    const rawLength = raw.length;
    const array = new Uint8Array(new ArrayBuffer(rawLength));

    for (let i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }

  chooseNew() {
    this.fileAsBase64 = null;
    this.fileName = null;
    this.fileAsBinary = null;
  }
}
